import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";

import moment from "moment";

import AlertService from "../../../components/SweetAlert";
import ToastUtil from "../../../components/ToastNotification/ToastUtil";
import { config } from "../../../config/index";
import { to12Hr } from "../../../helpers/moment";
const { API_URL } = config;

const ApplyShift = ({
  setActiveDate,
  history,
  activeDate,
  siteShifts,
  siteSchedules,
  activeSchedules,
  client,
}) => {
  const token = localStorage.getItem("token");
  const [selectedShifts, setSelectedShifts] = useState([]);
  const [shifts, setShifts] = useState([]);

  const isSelected = (shift_id) => selectedShifts.some((id) => id === shift_id);
  const togglePreferenceBtn = (shift_id) =>
    isSelected(shift_id) ? removeSelected(shift_id) : addSelected(shift_id);

  const addSelected = (shift_id) => {
    let clone = JSON.parse(JSON.stringify(selectedShifts));
    clone.push(shift_id);
    setSelectedShifts(clone);
  };

  const removeSelected = (shift_id) => {
    let clone = JSON.parse(JSON.stringify(selectedShifts));
    let filtered = clone.filter((id) => id !== shift_id);
    setSelectedShifts(filtered);
  };

  const fetchApplyShift = async (id) => {
    try {
      let url = `${API_URL}/associate/shifts/${id}/apply`;

      let response = await fetch(url, {
        mode: "cors",
        method: "POST",
        withCredentials: true,
        headers: {
          Authorization: token,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json charset=utf-8",
        },
      });

      let data = await response.json();

      return data;
    } catch (error) {
      console.log(error);
    }
  };

  const submitApplyShift = async () => {
    if (
      await AlertService.confirm(
        "",
        "Are you sure you want to apply for the selected shifts?"
      )
    ) {
      let arr = siteSchedules.filter(
        (schedule) => schedule.date === moment(activeDate).format("YYYY-MM-DD")
      );

      let selectedSchedules = arr.filter((schedule) =>
        selectedShifts.some((shift_id) => shift_id === schedule.shift_id)
      );
      let scheduleIds = selectedSchedules.map((schedule) => schedule.id);
      let results = scheduleIds.map(async (id) => await fetchApplyShift(id));
      let resolve = await Promise.all(results);
      let success = resolve.find((response) => !response.success)
        ? false
        : true;

      if (success) {
        ToastUtil.success("Shifts applied successfully!");
        setActiveDate(moment());
        setActiveDate(activeDate);
      } else {
        ToastUtil.error(resolve.find((response) => !response.success).message);
      }
    }
  };

  useEffect(() => {
    const scheduleShifts = [...siteShifts].filter((shift) =>
      siteSchedules.some((schedule) => schedule.shift_id === shift.id)
    );

    setShifts([...scheduleShifts]);
  }, [siteShifts, siteSchedules]);

  return (
    <React.Fragment>
      {client && client.enable_br_upload === true && (
        <div className="container py-2">
          <div className="shadow-sm border-0 rounded preffered-shift-container bg-white">
            <div className="container pb-2">
              <h6 className="py-2">Apply for Shifts</h6>
              {shifts
                .sort(
                  (a, b) =>
                    moment(a.start_time, "HH:mm:ss") -
                    moment(b.start_time, "HH:mm:ss")
                )
                .map((shift) => {
                  if (activeSchedules.length > 0) {
                    if (
                      !activeSchedules.some(
                        (schedule) => schedule.shift_id === shift.id
                      )
                    ) {
                      return (
                        <button
                          key={shift.id}
                          className={
                            "btn btn-light btn-block py-1 text-left rounded" +
                            (isSelected(shift.id) ? " btn-dark" : "")
                          }
                          disabled={
                            (siteSchedules.find(
                              (schedule) => schedule.shift_id === shift.id
                            ) &&
                              siteSchedules.find(
                                (schedule) => schedule.shift_id === shift.id
                              ).filled_slots >=
                                siteSchedules.find(
                                  (schedule) => schedule.shift_id === shift.id
                                ).slots.slots) ||
                            moment().isAfter(
                              moment(
                                moment().format("YYYY-MM-DD") +
                                  " " +
                                  shift.end_time
                              )
                            )
                          }
                          onClick={() => togglePreferenceBtn(shift.id)}
                        >
                          {`${shift.name ? shift.name : "Shift"} (${to12Hr(
                            shift.start_time
                          )} - ${to12Hr(shift.end_time)})`}
                        </button>
                      );
                    }
                  } else {
                    return (
                      <button
                        key={shift.id}
                        className={
                          "btn btn-light btn-block py-1 text-left rounded" +
                          (isSelected(shift.id) ? " btn-dark" : "")
                        }
                        // disabled={disablePreferenceBtn(shift.id)}
                        onClick={() => togglePreferenceBtn(shift.id)}
                      >
                        {`${shift.name ? shift.name : "Shift"} (${to12Hr(
                          shift.start_time
                        )} - ${to12Hr(shift.end_time)})`}
                      </button>
                    );
                  }
                })}
              <button
                disabled={selectedShifts.length === 0}
                className="btn btn-light btn-block mt-4 rounded"
                onClick={() => submitApplyShift()}
              >
                Confirm shift
              </button>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default withRouter(ApplyShift);
